import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const GridMoveIcon = ({ color = '#0D84FE', size = 26, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={color}
      d="m12 3 .625-.78-.625-.5-.625.5L12 3Zm-1 6a1 1 0 1 0 2 0h-2Zm5.625-3.58-4-3.2-1.25 1.56 4 3.2 1.25-1.56Zm-5.25-3.2-4 3.2 1.25 1.56 4-3.2-1.25-1.56ZM11 3v6h2V3h-2ZM21 12l.78.625.5-.625-.5-.625L21 12Zm-6-1a1 1 0 1 0 0 2v-2Zm3.58 5.625 3.2-4-1.56-1.25-3.2 4 1.56 1.25Zm3.2-5.25-3.2-4-1.56 1.25 3.2 4 1.56-1.25ZM21 11h-6v2h6v-2ZM12 21l.625.78-.625.5-.625-.5L12 21Zm-1-6a1 1 0 1 1 2 0h-2Zm5.625 3.58-4 3.2-1.25-1.56 4-3.2 1.25 1.56Zm-5.25 3.2-4-3.2 1.25-1.56 4 3.2-1.25 1.56ZM11 21v-6h2v6h-2ZM3 12l-.78.625-.5-.625.5-.625L3 12Zm6-1a1 1 0 1 1 0 2v-2Zm-3.58 5.625-3.2-4 1.56-1.25 3.2 4-1.56 1.25Zm-3.2-5.25 3.2-4 1.56 1.25-3.2 4-1.56-1.25ZM3 11h6v2H3v-2Z"
    />
  </svg>
);

GridMoveIcon.propTypes = propTypes;

export default GridMoveIcon;
